export enum StockStatus {
    Anticipated = 'Anticipated',
    SaleOrder = 'SaleOrder',
    dummy = 'dummy',
    superDummy = 'Super Dummy',
}